(() => {
  'use strict';
  if (window.__premierSearchTracking) return;
  window.__premierSearchTracking = true;
  const measurementId = 'G-3JGML5ZLZK';
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  function context() {
    if (!/^\/a\/search\/?$/.test(location.pathname)) return null;
    const params = new URLSearchParams(location.search);
    const term = clean(params.get('q'));
    if (!term || term.length > 100 || /@|https?:\/\//i.test(term) || /(?:\+?\d[\s().-]*){9,}/.test(term)) return null;
    return { term, page: Math.max(1, Number(params.get('page')) || 1) };
  }
  const initial = context();
  const pendingKey = 'premier_search_click';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function send(name, data, controls = {}) {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', name, {
        ...data,
        search_provider: 'xcloud',
        source_path: data.source_path || location.pathname,
        send_to: measurementId,
        ...controls,
        ...(window.__premierSearchDebugMode === true ? { debug_mode: true } : {}),
        ...(window.__premierSearchTestMode === true ? { traffic_type: 'navigation_test' } : {})
      });
      return true;
    } catch (_) { return false; }
  }
  function clearPending() {
    try { window.sessionStorage.removeItem(pendingKey); } catch (_) {}
  }
  let pendingAttempts = 0;
  function flushPending() {
    let pending;
    try { pending = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null'); }
    catch (_) { clearPending(); return; }
    if (!pending) return;
    let referrer;
    try { referrer = new URL(document.referrer); } catch (_) { clearPending(); return; }
    if (!Number.isFinite(pending.created) || Date.now() - pending.created > 120000 ||
        pending.created > Date.now() || pending.data?.link_path !== location.pathname ||
        referrer.origin !== location.origin || referrer.pathname !== pending.data?.source_path) {
      clearPending();
      return;
    }
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed === 'function' && !allowed()) {
      clearPending();
      return;
    }
    if (allowed() && typeof window.gtag === 'function') {
      clearPending();
      send('search_result_click', pending.data);
      return;
    }
    if (++pendingAttempts < 40) setTimeout(flushPending, 500);
    else clearPending();
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) clearPending();
  });
  flushPending();
  if (!initial) return;
  function resultCount(term) {
    const main = document.querySelector('main');
    if (!main) return null;
    const totals = clean(main.querySelector('.cloud-search-page-controls__totals')?.textContent);
    const match = totals.match(/(?:\bof\s+)?([\d,]+)\s+results?\s+for\s+["“](.*)["”]/i);
    if (match && clean(match[2]) === term) {
      return Number(match[1].replace(/,/g, ''));
    }
    // Require explicit zero results; an empty grid may still be loading.
    const empty = Array.from(main.querySelectorAll('p[role="status"]'))
      .some(el => clean(el.textContent).includes(`No results found for “${term}”`));
    const zero = clean(main.querySelector('#ProductCountDesktop')?.textContent);
    return empty && /^0\s+results?$/i.test(zero) ? 0 : null;
  }
  let sent = false;
  let timer = null;
  let attempts = 0;
  let observedCount = null;
  function check() {
    timer = null;
    const current = context();
    if (sent || !current || current.term !== initial.term || !allowed()) return;
    const count = resultCount(current.term);
    if (count !== null && send('view_search_results', {
      search_term: current.term,
      results_count: count,
      search_has_results: count > 0 ? 'yes' : 'no',
      search_page: current.page
    })) {
      observedCount = count;
      sent = true;
      return;
    }
    if (++attempts < 120) timer = setTimeout(check, 500);
  }
  function start() {
    if (timer !== null) clearTimeout(timer);
    attempts = 0;
    check();
  }
  document.addEventListener('visitorConsentCollected', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || !(event.target instanceof Element) || !allowed()) return;
    const current = context();
    if (!current || current.term !== initial.term) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor || !anchor.closest('main #product-grid')) return;
    const card = anchor.closest('.product-card-wrapper');
    if (!card) return;
    let url;
    try { url = new URL(anchor.getAttribute('href'), location.href); } catch (_) { return; }
    if (url.origin !== location.origin || !/^\/products\/[^/]+\/?$/.test(url.pathname)) return;
    const grid = anchor.closest('#product-grid');
    const cards = Array.from(grid.querySelectorAll('.product-card-wrapper'));
    const data = {
      search_term: current.term,
      link_path: url.pathname,
      link_text: clean(card.querySelector('.card__heading')?.textContent).slice(0, 100),
      result_position_on_page: cards.indexOf(card) + 1,
      search_page: current.page,
      source_path: location.pathname,
      ...(observedCount !== null ? { results_count: observedCount } : {})
    };
    const target = (anchor.getAttribute('target') || document.querySelector('base[target]')?.getAttribute('target') || '_self').toLowerCase();
    const sameTab = event.cancelable && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey &&
      target === '_self' && !anchor.hasAttribute('download');
    if (sameTab) {
      try {
        window.sessionStorage.setItem(pendingKey, JSON.stringify({ created: Date.now(), data }));
        return;
      } catch (_) {}
    }
    send('search_result_click', data);
  }, true);
})();
